import { useMemo } from "react";

import { PremiumFeatureCard } from "../../Components/Trial/TrialPremiumFeatureCard";
import { useCustomerContext } from "../../Context/CustomerContext";
import { isCustomerInPresentationMode } from "../../Context/useCustomerOrPresentationModeCustomer";
import { getPremiumFeatureCardText } from "../CloudAnalytics/utilities";
import AlertList from "./AlertList";

const AnomalyDetection = () => {
  const { customer } = useCustomerContext();

  const premiumFeatureCardText = useMemo(() => getPremiumFeatureCardText("costAnomalies"), []);

  return (
    <>
      {isCustomerInPresentationMode(customer) && premiumFeatureCardText && (
        <PremiumFeatureCard
          title={premiumFeatureCardText.title}
          detail={premiumFeatureCardText.details}
          tryFor={premiumFeatureCardText.tryFor}
        />
      )}
      <AlertList />
    </>
  );
};

export default AnomalyDetection;
